module.exports = __webpack_public_path__ + "img/technoker1.6e1e08b2.png";